import { useEffect } from 'react';
import { dateWithTimeZone } from "../../../../../utilities/utils";

const ArkeeroPixel = ({ model }) => {
  useEffect(() => {
    let expirationDate = new Date("2024-09-01");//YYYY-MM-DD

    if( dateWithTimeZone() < expirationDate ) {
      if (model === 'Q3 Sportback') {
        const imgPixel1   = document.createElement('img');
        imgPixel1.src     = 'https://ads.go2perseo.com/trk_o?px=P8xAkhBU67M%3d&adv_sub=SUBID';
        imgPixel1.width   = 1;
        imgPixel1.height  = 1;
        imgPixel1.style   = 'display: none';
        imgPixel1.id      = "phd-arkeero-pixel-script";
        
        document.body.appendChild(imgPixel1);
      }

      if (model === 'Q5') {
        const imgPixel2   = document.createElement('img');
        imgPixel2.src     = 'https://ads.go2perseo.com/trk_o?px=jXWNhWXHPvo%3d&adv_sub=SUBID';
        imgPixel2.width   = 1;
        imgPixel2.height  = 1;
        imgPixel2.style   = 'display: none';
        imgPixel2.id      = "phd-arkeero-pixel-script";
        
        document.body.appendChild(imgPixel2);
      }
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model]);

  return (<></>);
};

export default ArkeeroPixel;